import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';

export function* getBordereauDownloadUrlSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getBordereauDownloadUrl', value: true }));
        const session = yield getSessionSaga();
        const guid = action.payload;

        const response = yield call(fetch, `/api/BordereauSummary/download-url/${guid}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        if (result.operation) {
            yield put(reduceOperation(result.operation));
            if (!result.operation.status) return;
        }

        if (result.downloadUrl) {
            // Fetch file as blob to enable custom filename (download attribute doesn't work cross-origin)
            const fileResponse = yield call(fetch, result.downloadUrl);
            const blob = yield call([fileResponse, 'blob']);
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = result.fileName || 'bordereau.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        }
    } catch (error) {
        console.log('Error while calling Get Bordereau Download URL API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getBordereauDownloadUrl', value: false }));
    }
}
